const addSpaces = (value: string) => value.replace(/\d(?=(\d{3})+\.)/g, '$& ');

export default addSpaces;
